import { useCustomTypes } from "PFCore/helpers/use_custom_types";
import { TableColumn } from "PFTypes";
import { useMemo } from "react";

const useCustomInterestColumns = (): {
  customColumns: TableColumn[];
} => {
  const { customTypes } = useCustomTypes();

  const customColumns: TableColumn[] = useMemo(
    () =>
      (customTypes || [])
        .filter((customType) => !!customType.sections.find((section) => section.key === "filters_interest"))
        .map((customType) => ({
          name: customType.name || "",
          title: customType.display_as || "",
          order: customType.position,
          kind: customType.kind,
          type: "custom_field",
          attribute: ["profile", customType.name || ""]
        })),
    [customTypes]
  );

  return { customColumns };
};

export default useCustomInterestColumns;
